import { queryCommonFlags } from "@/api/constants";
import { useQuery } from "@tanstack/react-query";
import { fetchTrackTypesLookups } from "../../api/property-management";
import { useOrganization } from "../../context/organizations/get-user-organizations.provider";

const useTrackTypesFilterOptions = ({
  organizationUId,
}: {
  organizationUId?: string;
} = {}) => {
  const { selectedOrganization, selectedOrganizations } = useOrganization();

  const organizationUIds = selectedOrganizations.length
    ? selectedOrganizations.map((org) => org.uid).join(",")
    : selectedOrganization
    ? selectedOrganization.uid
    : "";

  const filterOrgUId = organizationUId || organizationUIds;

  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ["trackTypes", filterOrgUId],
    queryFn: () =>
      fetchTrackTypesLookups({
        organizationUIds: filterOrgUId,
      }),
    ...queryCommonFlags,
    staleTime: 60000,
    select: (data) => ({
      data: data.data.map((item) => ({
        ...item,
        key: item.ids
          ? item.ids.join(",")
          : (item.ids?.[0] as unknown as number)?.toString() ?? "",
      })),
    }),
  });

  return {
    data: data?.data,
    error,
    isLoading,
    refetch,
  };
};

export default useTrackTypesFilterOptions;
